import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const CutleryIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4.25C3.41421 4.25 3.75 4.58579 3.75 5V8C3.75 8.97966 4.37611 9.81309 5.25 10.122V5C5.25 4.58579 5.58579 4.25 6 4.25C6.41421 4.25 6.75 4.58579 6.75 5V10.122C7.62389 9.81309 8.25 8.97966 8.25 8V5C8.25 4.58579 8.58579 4.25 9 4.25C9.41421 4.25 9.75 4.58579 9.75 5V8C9.75 9.81422 8.46168 11.3275 6.75 11.675V16C6.75 16.4142 6.41421 16.75 6 16.75C5.58579 16.75 5.25 16.4142 5.25 16V11.675C3.53832 11.3275 2.25 9.81422 2.25 8V5C2.25 4.58579 2.58579 4.25 3 4.25ZM14.75 11.6531C16.256 11.2531 17.25 9.67298 17.25 8C17.25 6.06278 15.9172 4.25 14 4.25C12.0828 4.25 10.75 6.06278 10.75 8C10.75 9.67298 11.744 11.2531 13.25 11.6531V16C13.25 16.4142 13.5858 16.75 14 16.75C14.4142 16.75 14.75 16.4142 14.75 16V11.6531ZM14 10.25C13.1557 10.25 12.25 9.37649 12.25 8C12.25 6.62351 13.1557 5.75 14 5.75C14.8443 5.75 15.75 6.62351 15.75 8C15.75 9.37649 14.8443 10.25 14 10.25Z"
        fill="currentIcon"
      />
    </SvgIcon>
  );
};
